import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import * as z from "zod";
import { AddressSchema } from "model/organization/schema";

const OrganizationCreateSchema = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.number(),
  }),
});

export const MutateOrganizationCreateParamsSchema = z.object({
  name: z.string(),
  isActive: z.boolean(),
  address: AddressSchema.nullable(),
});

export type MutateOrganizationCreateParams = z.infer<typeof MutateOrganizationCreateParamsSchema>;

export const mutateOrganizationCreate = async (values: MutateOrganizationCreateParams) => {
  const response = await makeMutation(ApiEndpoints.organizationList(), values, true);
  return OrganizationCreateSchema.parse(response);
};
